import { render, staticRenderFns } from "./BrandBalkam.vue?vue&type=template&id=71f11804&scoped=true&"
import script from "./BrandBalkam.vue?vue&type=script&lang=js&"
export * from "./BrandBalkam.vue?vue&type=script&lang=js&"
import style0 from "./BrandBalkam.vue?vue&type=style&index=0&id=71f11804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f11804",
  null
  
)

export default component.exports